$(function () {

  // Mobile menu
  var $phone = $('.header-contacts-item-phone > div:first');

  $('header').after('<div id="mobile_menu" class="mobile_menu">' +
    '<div class="call"><a href="tel:' + $phone.data('phone-link') + '" class="phone">' + $phone.data('phone') + '</a></div>' +
    '</div><div id="nav"></div>');

  $('nav ul').clone().prependTo('#nav').removeAttr('class').removeAttr('id');
  $('#nav > ul > li').eq(0).before('<li class="tours"><a href="#tours">Туры</a><ul id="tours"></ul></li>');
  $('.left-menu li a').clone().appendTo('#tours').wrap('<li></li>');
  $('#nav > li#hire a').clone().appendTo('.call');

  $('#nav').slicknav({
    label: '',
    duration: 500
  });

  // Дублируем и фиксируем кнопку "Оставить заявку"
  var $obt = $('.order-button-top'),
      $obb = $('.order-button-bottom'),
      $aside = $('aside#left');

  if ($obt.length) {
    function fixOB() {
      if (($(window)[0].innerWidth || $(window).width()) <= 768) {
        return false;
      }
      var scrollTop = $(window).scrollTop(),
          lmTop = $aside.find('.left-menu').offset().top,
          obbTop = $obb.offset().top - parseFloat($obb.css('marginTop'));
      if (scrollTop >= lmTop && scrollTop < obbTop) {
        $obb.addClass('show');
      } else {
        $obb.removeClass('show');
      }
      if (scrollTop >= obbTop) {
        $obt.addClass('fixed');
      } else {
        $obt.removeClass('fixed');
      }
    }

    fixOB();
    $(window).on('load resize scroll', fixOB);
    if (GLOBAL.isTouchscreen) {
      $(document).on('touchmove MSPointerMove pointermove', fixOB);
    }
  }

  // Анимация кнопки "Оставить заявку"
  $('.order-button').everyTime('10s', function () {
    var self = this;
    $(this).addClass('animated').oneTime(1300, function () {
      $(self).removeClass('animated');
    });
  });

  // Анимация логотипа
  $('.logo').everyTime('15s', function () {
    var self = this;
    $(this).addClass('animated').oneTime(500, function () {
      $(self).removeClass('animated');
    });
  });

  // Ротатор фона
  var settings = {
    delay: 10000,
    fade: 1500,
    backgrounds: _.shuffle([
      { src: 'temp/backgrounds/01.jpg' },
      { src: 'temp/backgrounds/02.jpg' },
      { src: 'temp/backgrounds/03.jpg' },
      { src: 'temp/backgrounds/05.jpg' },
      { src: 'temp/backgrounds/06.jpg' },
      { src: 'temp/backgrounds/07.jpg' },
      { src: 'temp/backgrounds/08.jpg' },
      { src: 'temp/backgrounds/09.jpg' },
      { src: 'temp/backgrounds/10.jpg' },
      { src: 'temp/backgrounds/11.jpg' },
      { src: 'temp/backgrounds/12.jpg' },
      { src: 'temp/backgrounds/13.jpg' },
      { src: 'temp/backgrounds/14.jpg' },
      { src: 'temp/backgrounds/15.jpg' },
      { src: 'temp/backgrounds/16.jpg' },
      { src: 'temp/backgrounds/17.jpg' },
      { src: 'temp/backgrounds/18.jpg' },
      { src: 'temp/backgrounds/19.jpg' },
      { src: 'temp/backgrounds/20.jpg' }
    ])
  };
  if ($('body').hasClass('index')) {
    var vegasConfig = {
      src: '/css/jquery.vegas/overlays/02.png'
    }
    if (!GLOBAL.isTouchscreen) {
      $.vegas('slideshow', settings)('overlay', vegasConfig);
    } else {
      $.vegas(settings.backgrounds[Math.floor(Math.random() * settings.backgrounds.length)])('overlay', vegasConfig);
    }
  } else {
    $.vegas(settings.backgrounds[Math.floor(Math.random() * settings.backgrounds.length)])('overlay', vegasConfig);
  }

  // Colorbox
  $('.colorbox').colorbox({
    scrolling: false,
    maxWidth: '90%',
    maxHeight: '90%',
    opacity: .8
  });

});